import styled from "styled-components";
import colours from "../../lib/colours";
import ReactSwitch from "react-switch";

const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  height: 42px;
  color: ${colours.th1l2};
  font-weight: 600;
  transition: background-color 0.2s linear, color 0.2s linear;
  &:hover {
    color: ${colours.th1};
  }
`;

const SwitchLabelDisabled = styled(SwitchLabel)`
  cursor: not-allowed;
  color: ${colours.th1l3};
  &:hover {
    color: ${colours.th1l3};
  }
`;

const SwitchLabelSpan = styled.span``;

interface IProps {
  id: string;
  onChange: any;
  checked: boolean;
  label?: string;
  labelChecked?: string;
  labelUnchecked?: string;
  disabled?: boolean;
  hideControl?: boolean;
}

const Switch = ({
  id,
  onChange,
  checked,
  label,
  labelChecked,
  labelUnchecked,
  disabled,
  hideControl,
}: IProps) => {
  const SwitchLabelComponent = disabled ? SwitchLabelDisabled : SwitchLabel;
  return (
    <SwitchLabelComponent htmlFor={id}>
      {!hideControl && (
        <ReactSwitch
          id={id}
          onChange={onChange}
          checked={checked}
          checkedIcon={false}
          uncheckedIcon={false}
          height={22}
          width={48}
          offColor={colours.grey2}
          onColor={colours.th2}
          disabled={disabled}
          className={disabled ? "react-switch-disabled" : ""}
        />
      )}
      <SwitchLabelSpan
        style={{
          color: checked ? colours.th1 : "unset",
          marginLeft: hideControl ? "2px" : "8px",
        }}
      >
        {checked ? labelChecked || label : labelUnchecked || label}
      </SwitchLabelSpan>
    </SwitchLabelComponent>
  );
};

export default Switch;
